export default __webpack_public_path__ + "static/media/sports-live.7944477a.svg";